import React, { useState } from "react";

import {
  Elements,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

// Your publishable key
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_TEST_PK);

const ELEMENT_STYLE = {
  base: {
    color: "#32325d",
    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
    fontSmoothing: "antialiased",
    fontSize: "16px",
    "::placeholder": { color: "#aab7c4" },
    backgroundColor: "#ffffff",
    border: "1px solid #ced4da",
    borderRadius: "4px",
    padding: "10px",
  },
  invalid: {
    color: "#fa755a",
    iconColor: "#fa755a",
  },
};

const Subscribe = () => {
  ///console.log(process.env.REACT_APP_STRIPE_TEST_PK);
  const stripe = useStripe();
  const elements = useElements();

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");

  const PRICE_ID = "price_YOUR_MONTHLY_PRICE_ID_HERE";

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setLoading(true);
    setMessage("");

    // 1. Create PaymentMethod (saves card securely)
    const cardNumber = elements.getElement(CardNumberElement);

    const { error: pmError, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: cardNumber,
      billing_details: { name, email },
    });

    if (pmError) {
      setMessage(pmError.message);
      setLoading(false);
      return;
    }

    // 2. Send PaymentMethod ID to server to save card + start subscription
    const resp = await fetch("http://localhost:4242/save-card-and-subscribe", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        paymentMethodId: paymentMethod.id,
        email,
        name,
        priceId: PRICE_ID,
      }),
    });

    const data = await resp.json();

    if (data.error) {
      setMessage(data.error);
    } else if (data.requires_action) {
      // Handle 3D Secure if needed
      const { error } = await stripe.confirmCardPayment(data.clientSecret);
      if (error) setMessage(error.message);
      else setMessage("Subscription started successfully! Card saved 🎉");
    } else {
      setMessage("Subscription started successfully! Card saved 🎉");
    }

    setLoading(false);
  };

  return (
    // <div className="templegrid">
    //   <div className="templegrid-courtyard-setting"></div>
    //   <div className="giftbox">
    //     <div className="subscribe">
    //       <div>Subscribe</div>

    //       <div className="giftbox-status">Angel x1</div>
    //       <div className="giftbox-gobutton">login</div>

    //     </div>
    //   </div>
    // </div>
    <form onSubmit={handleSubmit}>
      <h2>Start Monthly Subscription</h2>
      <input
        type="text"
        placeholder="Full Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        required
        style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
      />
      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
      />

      <label>Card Number</label>
      <CardNumberElement options={{ style: ELEMENT_STYLE }} />

      <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
        <div style={{ flex: 1 }}>
          <label>Expiry Date</label>
          <CardExpiryElement options={{ style: ELEMENT_STYLE }} />
        </div>
        <div style={{ flex: 1 }}>
          <label>CVC</label>
          <CardCvcElement options={{ style: ELEMENT_STYLE }} />
        </div>
      </div>

      <button
        type="submit"
        disabled={loading || !stripe}
        style={{ marginTop: "20px", padding: "12px", width: "100%" }}
      >
        {loading ? "Processing..." : "Subscribe & Save Card"}
      </button>

      {message && <p style={{ marginTop: "10px", color: "red" }}>{message}</p>}
    </form>
  );
};

const SubscriptionForm = () => (
  <Elements stripe={stripePromise}>
    <Subscribe />
  </Elements>
);

export default SubscriptionForm;
